"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateURLParameters = exports.sanitizeValue = exports.replacePlaceHolders = exports.queryStringToObject = exports.normalizeAddress = exports.makeHTTPRequest = exports.isStepInput = exports.isPopulatedString = exports.isNotEmptyObject = exports.isInputNotEmpty = exports.isInputEmpty = exports.getValueByDotNotation = exports.getRedirectURL = exports.getRecaptchaKey = exports.getQueryStringValue = exports.getMetaData = exports.getLanguage = exports.getCookies = exports.formatLabel = exports.formatAddressLabel = exports.flattenObject = exports.fieldWidthsToFlexGridSizes = exports.extractFieldValues = exports.default = exports.createNestedObject = exports.checkStepTrackerConfigError = exports.checkDynamicValues = exports.addressFieldPayloadMapper = void 0;
require("url-search-params-polyfill");
var _staticContent = require("./staticContent");
var _constants = require("./constants");
var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // A collection of utility functions
var IS_LOCAL_DEV = "production" === _constants.LOCAL_DEV_ENVIRONMENT;

// Checks to see if the value passed is a string and is not empty (excluding whitespace)
var isPopulatedString = str => typeof str === 'string' && str.trim().length > 0;

// We should let child components handle the case using default props
// Also to avoid passing in empty string causing the following TDS issue
// https://github.com/telus/tds-core/issues/1121
// The required indicator is used to add 'optional' translated based on lang
// as required in TDS Forms: https://tds.telus.com/components/index.html#/Forms
exports.isPopulatedString = isPopulatedString;
var formatLabel = (label, isRequired, lang) => typeof label === 'string' && label.length > 0 ? "".concat(label).concat(isRequired ? '' : " (".concat(_staticContent.OPTIONAL[lang], ")")) : undefined;

// A simple util function to return 'en'/'fr' for validation err msg translation (current usecase)
// As this code is re-used across multiple components, abstract and put into utils
exports.formatLabel = formatLabel;
var getLanguage = locale => {
  var lang = locale.split('-')[0];
  if (lang !== _constants.CONTENTFUL_LOCALE.en && lang !== _constants.CONTENTFUL_LOCALE.fr) {
    // Showing a console error here will help us in troubleshooting locale issues
    // eslint-disable-next-line no-console
    console.error("Error: not sure how to handle locale: ".concat(locale, ", default to ").concat(_constants.CONTENTFUL_LOCALE.en));
    return _constants.CONTENTFUL_LOCALE.en;
  }
  return lang;
};

// function that translates a string value from selected option to its responsive width value
exports.getLanguage = getLanguage;
var fieldWidthsToFlexGridSizes = width => {
  var translatedWidth;
  switch (width) {
    case '1/4 of the row':
      translatedWidth = 3;
      break;
    case '1/2 of the row':
      translatedWidth = 6;
      break;
    case '3/4 of the row':
      translatedWidth = 9;
      break;
    default:
      translatedWidth = 12;
  }
  return translatedWidth;
};

// returns query string value if param present, otherwise empty string
exports.fieldWidthsToFlexGridSizes = fieldWidthsToFlexGridSizes;
var getQueryStringValue = param => {
  var queryString = new URLSearchParams(window.location.search);
  return queryString.has(param) ? queryString.get(param) : '';
};
exports.getQueryStringValue = getQueryStringValue;
var generateBackendURLs = origin => ({
  staging: "".concat(_constants.FORM_API_GKE_STAGING, "/").concat(_constants.API_VERSION, "/form/"),
  nonProd: "".concat(origin).concat(_constants.FORM_API_ENDPOINT_PATH, "/").concat(_constants.API_VERSION, "/form/"),
  develop: "".concat(_constants.FORM_API_GKE_DEVELOP, "/").concat(_constants.API_VERSION, "/form/"),
  local: "".concat(_constants.FORM_API_LOCALHOST, "/").concat(_constants.API_VERSION, "/form/"),
  prod: "".concat(_constants.FORM_API_PROD).concat(_constants.FORM_API_ENDPOINT_PATH, "/").concat(_constants.API_VERSION, "/form/")
});
var getBackendURL = () => {
  var {
    origin
  } = window.location;
  var {
    staging,
    develop,
    nonProd,
    prod,
    local
  } = generateBackendURLs(origin);
  if (_constants.NON_PROD_DOMAINS.includes(origin)) return nonProd;

  // Due to non prod basic auth cross domain, use FB staging gke route directly
  if (_constants.NON_PROD_KOODO_DOMAINS.test(origin)) return staging;

  // for requests from gke routes (testing purposes), use FB develop gke route
  if (origin.endsWith(_constants.DEVELOP_GKE_DOMAIN)) return develop;

  // for requests from gke routes (testing purposes), use FB develop gke route
  if (origin.endsWith(_constants.GKE_DOMAIN)) return staging;

  // prod and preview requests
  if (_constants.PROD_DOMAINS.includes(origin)) return prod;

  // for requests from SB2 review env
  if (origin.endsWith(_constants.NON_PROD_DOMAIN_REVIEW)) return staging;

  // All other cases, use localhost
  return local;
};
var generateRedirectionURLs = (origin, redirectSlug) => ({
  nonProd: "".concat(origin).concat(redirectSlug),
  staging: "".concat(_constants.FORM_API_GKE_STAGING, "/").concat(redirectSlug),
  develop: "".concat(_constants.FORM_API_GKE_DEVELOP, "/").concat(redirectSlug),
  prod: "".concat(_constants.FORM_API_PROD).concat(_constants.FORM_API_ENDPOINT_PATH, "/").concat(redirectSlug),
  local: "".concat(_constants.FORM_API_LOCALHOST, "/").concat(redirectSlug)
});
var getRedirectURL = redirectSlug => {
  var {
    origin
  } = window.location;
  var {
    nonProd,
    staging,
    develop,
    prod,
    local
  } = generateRedirectionURLs(origin, redirectSlug);
  if (_constants.NON_PROD_DOMAINS.includes(origin)) return nonProd;

  // Due to non prod basic auth cross domain, use FB staging gke route directly
  if (_constants.NON_PROD_KOODO_DOMAINS.test(origin)) return staging;
  if (origin.endsWith(_constants.DEVELOP_GKE_DOMAIN)) return develop;

  // for requests from gke routes (testing purposes), use FB develop gke route
  if (origin.endsWith(_constants.GKE_DOMAIN)) return staging;

  // prod and preview
  if (_constants.PROD_DOMAINS.includes(origin)) return prod;

  // for requests from SB2 review env
  if (origin.endsWith(_constants.NON_PROD_DOMAIN_REVIEW)) return staging;

  // All other cases, use localhost
  return local;
};

// We will send the most generic metadata (see return obj) on form submission
// as most data adapter would need most if not all of this information, and they can only
// be obtained on the client side.
exports.getRedirectURL = getRedirectURL;
var getMetaData = () => {
  var cookies = document.cookie.split(/; */).map(cookie => {
    var [key, ...value] = cookie.split('=');
    return [key, decodeURIComponent(value.join('='))];
  })
  // Alternative to Object.fromEntries(Node 12 and above), as not all our CI/CD are using Node 12
  .reduce((object, _ref) => {
    var [key, value] = _ref;
    return Object.assign(object, {
      [key]: value
    });
  }, {});

  // prov and lang to fall back to bc and en as most endpoints have these two defined as enum
  var prov = cookies.prov || _constants.COOKIES_PROV_FALLBACK;
  var lang = cookies.lang || _constants.COOKIES_LANG_FALLBACK;
  var webLastTouch = cookies[_constants.COOKIES_PRODUCT_NAME] || '';

  // get query string values
  var leadProduct = getQueryStringValue(_constants.QUERY_STRING_PRODUCT);
  var externalTrackingCode = getQueryStringValue(_constants.QUERY_STRING_CAMPAIGN);
  var intcmp = getQueryStringValue(_constants.QUERY_STRING_INTERNAL_CAMPAIGN);
  var topic = getQueryStringValue(_constants.QUERY_STRING_TOPIC);
  // prospectID is used in the FB API DataHub adapter
  var prospectID = getQueryStringValue(_constants.QUERY_STRING_PROSPECT_ID);
  var urlQuery = queryStringToObject(window.location.href);

  // Instead of fetching via cookies through name "AMCV_67A50FC0539F0BBD0A490D45%40AdobeOrg"
  // analytics team provided two objects that contains this value, as stated below
  var MCID = window && window.s && window.s.marketingCloudVisitorID || window && Array.isArray(window.s_c_il) && window.s_c_il[1] && window.s_c_il[1].marketingCloudVisitorID || window && Array.isArray(window.s_c_il) && window.s_c_il[0] && 'getMarketingCloudVisitorID' in window.s_c_il[0] && window.s_c_il[0].getMarketingCloudVisitorID() || '';
  var UUID = window && window.localStorage && window.localStorage.uuid || '';
  var pageName = window && window.dataLayer && window.dataLayer.page && window.dataLayer.page.name;
  return {
    prov,
    lang,
    MCID,
    UUID,
    webLastTouch,
    leadProduct,
    externalTrackingCode,
    intcmp,
    topic,
    prospectID,
    // Used in the FB API DataHub adapter
    pageName,
    urlQuery
  };
};
exports.getMetaData = getMetaData;
var makeHTTPRequest = exports.makeHTTPRequest = function makeHTTPRequest(body, accessToken, isProduction, accessConfig) {
  var basePath = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var method = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : _constants.HTTP_GET;
  var files = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  var headers = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
  var options = {
    method,
    headers: _objectSpread({
      [_constants.HEADER_CONTENT_TYPE]: _constants.HEADER_CONTENT_TYPE_JSON,
      [_constants.HEADER_ACCESS_CONFIG]: accessConfig
    }, headers),
    mode: 'cors',
    cache: 'no-cache'
  };

  // Add on the basic auth for staging
  if (!isProduction && !IS_LOCAL_DEV) {
    options.credentials = 'include';
  } else if (IS_LOCAL_DEV) {
    // for local dev and review link, we need to add the cookies to the request manually as the browser will not
    var cookies = getCookies();
    options.headers['Cookies'] = Object.entries(cookies).map(_ref2 => {
      var [key, value] = _ref2;
      return "".concat(key, "=").concat(value);
    }).join('; ');
  }
  var url = '';
  if (accessToken !== '') options.headers[_constants.HEADER_ACCESS_TOKEN] = accessToken;
  if (method === _constants.HTTP_GET) {
    var queryString = Object.keys(body).filter(key => body[key] !== undefined).map(key => "".concat(key, "=").concat(body[key])).join('&');
    url = "".concat(getBackendURL()).concat(basePath, "?").concat(queryString);
  } else {
    options.body = body;
    url = "".concat(getBackendURL()).concat(basePath);
  }
  if (files.length > 0) {
    var formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    formData.append('fbdata', body);
    options.body = formData;
    delete options.headers[_constants.HEADER_CONTENT_TYPE];
  }
  return (0, _isomorphicFetch.default)(url, options);
};
var getRecaptchaKey = (isProduction, formData) => {
  var siteKey = isProduction || (formData === null || formData === void 0 ? void 0 : formData.environment) === _constants.CONTENTFUL.SPACES.SB2.ENVIRONMENTS.MASTER && formData !== null && formData !== void 0 && formData.usePreviewAPI ? _constants.GCP_PROD_RECAPTCHA_SITE_KEY : _constants.GCP_DEV_RECAPTCHA_SITE_KEY;
  return siteKey;
};

/**
 * Validates if the specified URL parameters are present and non-empty in the given URL parameters object.
 * @param {string[]} urlParametersToVerify - Array of parameter names to verify.
 * @param {Object} urlParams - Object containing URL parameters as key-value pairs.
 * @returns {boolean} - Returns true if all specified parameters are present and non-empty, otherwise false.
 */
exports.getRecaptchaKey = getRecaptchaKey;
var validateURLParameters = exports.validateURLParameters = function validateURLParameters() {
  var urlParametersToVerify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var urlParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return urlParametersToVerify.every(param => urlParams[param] && urlParams[param].toString().length > 0);
};

/* 
  Recursivly call the function over the address object,
  and return a new object with the flattened key-value pairs.
  The function iterates over objects and arrays, and returns a new object with the flattened key-value pairs.
*/
var _flattenObject = exports.flattenObject = function flattenObject(obj) {
  var parentKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  var result = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return Object.keys(obj).reduce((acc, key) => {
    var newKey = parentKey ? "".concat(parentKey).concat(separator).concat(key) : key;
    if (obj[key] && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
      _flattenObject(obj[key], newKey, separator, acc);
    } else if (Array.isArray(obj[key])) {
      obj[key].forEach((item, index) => {
        if (typeof item === 'object') {
          _flattenObject(item, "".concat(newKey, "[").concat(index, "]"), separator, acc);
        } else {
          acc["".concat(newKey, "[").concat(index, "]")] = item;
        }
      });
    } else {
      acc[newKey] = obj[key];
    }
    return acc;
  }, result);
};
var addressFieldPayloadMapper = (addressPayload, isLPDSIDRequired) => {
  var _addressPayload$paylo, _addressPayload$paylo2, _addressPayload$paylo3, _addressPayload$paylo4;
  var isLpdsIdAvailable = addressPayload.source !== undefined ? 'N/A' : null;
  var isFmsIdAvailable = addressPayload.source !== undefined ? 'N/A' : null;
  var lpdsId = isLPDSIDRequired ? ((_addressPayload$paylo = addressPayload.payload) === null || _addressPayload$paylo === void 0 ? void 0 : _addressPayload$paylo.id) !== undefined && ((_addressPayload$paylo2 = addressPayload.payload) === null || _addressPayload$paylo2 === void 0 ? void 0 : _addressPayload$paylo2.id) !== '' ? addressPayload.payload.id : isLpdsIdAvailable : isLpdsIdAvailable;

  // FMS ID
  var fmsId = isLPDSIDRequired ? ((_addressPayload$paylo3 = addressPayload.payload) === null || _addressPayload$paylo3 === void 0 || (_addressPayload$paylo3 = _addressPayload$paylo3.referenceId) === null || _addressPayload$paylo3 === void 0 ? void 0 : _addressPayload$paylo3.fmsId) !== undefined && ((_addressPayload$paylo4 = addressPayload.payload) === null || _addressPayload$paylo4 === void 0 || (_addressPayload$paylo4 = _addressPayload$paylo4.referenceId) === null || _addressPayload$paylo4 === void 0 ? void 0 : _addressPayload$paylo4.fmsId) !== '' ? addressPayload.payload.referenceId.fmsId : isFmsIdAvailable : isFmsIdAvailable;
  var mappedPayload = _flattenObject(addressPayload);
  return _objectSpread(_objectSpread({}, mappedPayload), {}, {
    lpdsId,
    fmsId
  });
};

// Format address label if its coming from Telus source
exports.addressFieldPayloadMapper = addressFieldPayloadMapper;
var formatAddressLabel = data => {
  var label = data === null || data === void 0 ? void 0 : data.address;
  if ((data === null || data === void 0 ? void 0 : data.source) === 'Telus') {
    label = label.toLowerCase().replace(/(^\w|\s\w|-\w)/g, letter => letter.toUpperCase());
    var labelArray = label.split(' ');
    // Address Prefix
    var addStringPrefix = labelArray.slice(0, labelArray.length - 2);
    // Keep province in UpperCase
    var addStringProvince = labelArray[labelArray.length - 2].toUpperCase();
    // Keep Postal Code in UpperCase and add space after 3 character
    var addStringPostalCode = labelArray[labelArray.length - 1].replace(/^(.{3})(.*)$/, '$1 $2').toUpperCase();
    label = addStringPrefix.join(' ') + ', ' + addStringProvince + ', ' + addStringPostalCode;
  }
  return label;
};

// Add this function to normalize the address
exports.formatAddressLabel = formatAddressLabel;
var normalizeAddress = address => {
  return address === null || address === void 0 ? void 0 : address.replace(/[^a-z0-9]/gi, '').toLowerCase();
};
exports.normalizeAddress = normalizeAddress;
var queryStringToObject = url => Object.fromEntries([...new URLSearchParams(url.split('?')[1])]);
exports.queryStringToObject = queryStringToObject;
var isStepInput = exports.isStepInput = function isStepInput() {
  var inputRef = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var currentStepReferences = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var isStepInput = false;
  if (!Array.isArray(currentStepReferences) || inputRef === null) {
    return isStepInput;
  }
  for (var stepReference of currentStepReferences) {
    if (stepReference.current && inputRef.current) {
      if (stepReference.current === inputRef.current) {
        isStepInput = true;
        break;
      }
    }
  }
  return isStepInput;
};
var checkStepTrackerConfigError = (formMetaData, consentField, showSummary) => {
  var result = {
    error: false,
    message: ''
  };
  if (formMetaData.fields.length > 1) {
    result.error = true;
    result.message = 'Please ensure that only the Step Tracker field is present in the form in Contentful.';
  } else if (consentField !== undefined) {
    result.error = true;
    result.message = 'Do not use the Consent field with the Step Tracker field outside of Step Tracker Steps in Contentful.';
  } else if ((formMetaData === null || formMetaData === void 0 ? void 0 : formMetaData.showSummary) === 'Yes' || showSummary === 'Yes') {
    result.error = true;
    result.message = 'Do not use the Summary option with the Step Tracker field in Contentful.';
  }
  return result;
};

// Use to check if the addressField body json ediotr is not empty
exports.checkStepTrackerConfigError = checkStepTrackerConfigError;
var isNotEmptyObject = obj => {
  return Object.entries(obj).length !== 0;
};

/*
 * @param {Object} templateObj - The object that contains the placeholders { "address": "${address}", "unit": "${unit}"}
 * @param {Object} dataObj - The object that contains the data to replace the placeholders {"address": "123 Main St", "unit": "Apt 101"}
 * @returns a JSON string with the placeholders replaced with the data
 */
exports.isNotEmptyObject = isNotEmptyObject;
var replacePlaceHolders = (placeHolders, fullAddressObj) => {
  var result = Object.keys(placeHolders).reduce((acc, key) => {
    var placeholderValue = placeHolders[key];
    //! Validate if we have a space
    var matches = placeholderValue.match(/\${(.*?)}/g);
    if (matches) {
      //! Replace each placeholder with its corresponding value from fullAddressObj
      var replacedValue = matches.reduce((str, match) => {
        var extractedKey = match.slice(2, -1); // Extract the key from ${key}
        var replacement = fullAddressObj[extractedKey] !== undefined ? fullAddressObj[extractedKey] : '';
        return str.replace(match, replacement); // Replace the placeholder with the actual value
      }, placeholderValue);
      acc[key] = replacedValue;
    } else {
      acc[key] = placeHolders[key]; //! If no placeholders, keep the original value
    }
    return acc;
  }, {});
  return JSON.stringify(result);
};
exports.replacePlaceHolders = replacePlaceHolders;
var extractFieldValues = (steps, targetFieldName) => {
  return steps.flatMap(obj => obj.fields).filter(obj => obj.fieldName === targetFieldName).map(obj => ({
    id: obj.id,
    fieldName: obj.fieldName
  }));
};
exports.extractFieldValues = extractFieldValues;
var createNestedObject = (keysObject, valuesObject) => {
  var result = {};
  function setValue(obj, keys, value) {
    var lastKey = keys.pop();
    keys.reduce((acc, key) => acc[key] = acc[key] || {}, obj)[lastKey] = value;
  }
  for (var key in keysObject) {
    var placeholderValue = keysObject[key];
    var replacedValue = placeholderValue.replace(/\${(.*?)}/g, (match, p1) => valuesObject[p1.trim()] || match);
    setValue(result, key.split('.'), replacedValue);
  }
  return result;
};

// Function that returns a boolean value based on whether all dynamic values are present
exports.createNestedObject = createNestedObject;
var checkDynamicValues = (keysObject, valuesObject) => {
  for (var key in keysObject) {
    var placeholderValue = keysObject[key];
    var replacedValue = placeholderValue.replace(/\${(.*?)}/g, (match, p1) => valuesObject[p1.trim()] || match);

    // Check if replacedValue contains '${}' and if so, check if corresponding value in valuesObject is empty
    if (/\${(.*?)}/.test(replacedValue)) {
      var placeholderKeys = replacedValue.match(/\${(.*?)}/g).map(match => match.slice(2, -1).trim());
      for (var placeholderKey of placeholderKeys) {
        if (!valuesObject[placeholderKey]) {
          return false; // Return false if any required value is missing
        }
      }
    }
  }

  // All required values are present
  return true;
};
exports.checkDynamicValues = checkDynamicValues;
var getValueByDotNotation = (obj, keyPath) => {
  if (!obj || typeof obj !== 'object') return;
  if (typeof keyPath !== 'string') return;
  var keys = keyPath.split('.');
  var value = obj;
  for (var key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      // Key not found in the path
      return undefined;
    }
  }
  return value;
};

/**
 * Gets all available cookies and their values.
 * @returns {Object} - An object with cookie names as keys and cookie values as values.
 */
exports.getValueByDotNotation = getValueByDotNotation;
var getCookies = () => {
  if (typeof document === 'undefined') {
    return {};
  }
  return document.cookie.split(';').reduce((cookies, cookie) => {
    var [name, value] = cookie.split('=').map(c => c.trim());
    cookies[name] = value;
    return cookies;
  }, {});
};

// replace all new lines and tab spaces
exports.getCookies = getCookies;
var sanitizeNewLine = value => value.replace(/\r?\n|\r/g, '');

// replace tags and their contents
var sanitizeTags = value => {
  var previous;
  do {
    previous = value;
    // Remove complete tag pairs first
    value = value.replace(/<[^>]*?>.*?<\/[^>]*?>/gi, '');
    // Then remove any remaining opening or closing tags
    value = value.replace(/<\/?[^>]+(>|$)/g, '');
  } while (value !== previous);
  return value;
};

// replace tags,quotes and special characters
var sanitizeCharacters = value => value.replace(/[<>'"\\|/]/g, ' ');

// replace consecutive spaces
var sanitizeSpaces = value => value.replace(/\s+/g, ' ');

// replace SQL injection attempts
var sanitizeSql = value => value.replace(/\b(ALTER TABLE|CREATE TABLE|DROP TABLE|DROP DATABASE|SELECT|INSERT INTO|DELETE FROM|UPDATE|WHERE|SET|EXEC|UNION|ALL|NULL|CAST|CONVERT|DECLARE|TRUNCATE|SHOW|DESCRIBE|USE|GRANT|REVOKE|MERGE|CALL|EXPLAIN|WITH|INTO|VALUES|FROM|ORDER BY|GROUP BY|HAVING|LIMIT|OFFSET|JOIN|ON|AS|LIKE|IN|IS|NOT|AND|OR)\b.*?;/gi, '');
var sanitizeValue = value => sanitizeSql(sanitizeSpaces(sanitizeCharacters(sanitizeTags(sanitizeNewLine(value))))).trim();
exports.sanitizeValue = sanitizeValue;
var isInputNotEmpty = value => {
  return !/\s{2,}/.test(value) && value.trim().length > 0;
};
exports.isInputNotEmpty = isInputNotEmpty;
var isInputEmpty = value => {
  return /\s{2,}/.test(value) || value.trim().length === 0;
};
exports.isInputEmpty = isInputEmpty;
var utilsFields = {
  formatLabel,
  isPopulatedString,
  getLanguage,
  fieldWidthsToFlexGridSizes,
  getBackendURL,
  extractFieldValues,
  makeHTTPRequest
};
var _default = exports.default = utilsFields;